import { useIntl } from 'react-intl';

import { IImageFragment } from 'generated/sanity-graphql';
import { primitive } from 'styles/constants/primitives';

import {
  Badge,
  BadgeContainer,
  ItemThumbnailContainer,
  StyledPicture,
  ThumbnailBehind,
  ThumbnailBox,
} from './styled';

type ItemHighlighted = {
  name: string;
  image: IImageFragment;
};

interface IItemThumbnailWithBadge {
  totalItems: number;
  item: ItemHighlighted;
}

export const ItemThumbnailWithBadge = ({ totalItems, item }: IItemThumbnailWithBadge) => {
  const { formatMessage } = useIntl();
  const accessibilityLabelTotalItems = formatMessage(
    { id: 'totalItemsInTheOrder' },
    { amount: totalItems }
  );

  return (
    <ItemThumbnailContainer
      accessibilityRole="text"
      focusable
      accessible
      accessibilityLabel={accessibilityLabelTotalItems}
    >
      {Array.from({ length: 2 }).map((_, index) => (
        <ThumbnailBehind
          key={index}
          style={{
            transform: [{ rotate: index % 2 === 0 ? '12deg' : '-12deg' }],
          }}
        />
      ))}
      <ThumbnailBox>
        <BadgeContainer>
          <Badge variant="number-solid" bgColor={primitive.bk.$crunchyGreen}>
            {totalItems.toString()}
          </Badge>
        </BadgeContainer>
        {item && <StyledPicture image={item.image} accessibilityHidden alt={item.name} />}
      </ThumbnailBox>
    </ItemThumbnailContainer>
  );
};
